<template>
  <div class="card-container">
    <ul>
      <li class="card" v-for="box in boxes">
        <img class="card__icon" :src="checkMarkAsset" alt="" />
        <h2 class="card__title">{{$t(`${view}.CARD_CONTAINER_${box}_HEADING`)}}</h2>
        <div
          class="card__body"
          v-html="$t(`${view}.CARD_CONTAINER_${box}_BODY`)" />
      </li>
    </ul>
  </div>
</template>

<script>

import style from 'brave-cards/components/card-container.scss'
import checkMarkAsset from 'assets/img/bluecheck.png'
export default {
  data () {

    return {
      checkMarkAsset
    }
  },
  props: ['boxes', 'view']
}
</script>
